var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerraformLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0127 23.3807L33.8496 17.7065V6.34003L24.0127 12.0263V23.3807Z",
    fill: "#5C4EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0963 6.34003L22.9332 12.0263V23.3807L13.0963 17.7005V6.34003ZM2.17969 11.3605L12.0166 17.0407V5.68023L2.17969 0V11.3605ZM13.0963 30.3086L22.9332 35.9888V24.6283L13.0963 18.9481",
    fill: "#5C4EE5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraformLight);
export default __webpack_public_path__ + "static/media/terraformLight.fca0fa9345abfcc441f1f2d7a32940f9.svg";
export { ForwardRef as ReactComponent };